import React, { Component } from "react";
import "./Deals.css";
import { DealItem } from "./DealItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { Img } from "../UI/UI";
import { getImgUrl, limitText } from "../../Utility/Utility";

class Deals extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();
    this.category = "";

    this.dealsSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "ease-in-out",
      autoplaySpeed: 2000,
      speed: 2200,
      autoplay: false,
      lazyLoad: "ondemand",
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    this.deals = [
      {
        agentName: "Gate 1 Travel",
        desc: "9 Day Israel, A Journey for the Believer",
        price: "$1779",
        logo: "Deals/agents/Gate1Travel.png",
        link:
          "https://www.gate1travel.com/mediterranean/israel/2022/escorted/israel-escorted-9dilhlp22.aspx",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "christian",
      },

      {
        agentName: "Isram ISrael",
        desc: "Holyland Pilgrimage",
        price: "$2121",
        logo: "Deals/agents/isramisrael.png",
        link: "https://isramisraelusa.com/packages/holyland-pilgrimage/",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "christian",
      },

      {
        agentName: "Sita",
        desc: "The Holyland 8 Days",
        price: "$2,400",
        logo: "Deals/agents/SITA-World-Tours-White-1.png",
        link:
          "https://sitatours.com/vacation-destinations/middle-east/israel/the-holyland/",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "christian",
      },
      {
        agentName: "Ya'lla Tours USA",
        desc: "Israel Highlights Tour",
        price: "$1,845",
        logo: "Deals/agents/yalla.jpg",
        link: "https://www.yallatours.com/israel/israel_highlights.shtml",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "christian",
      },
      {
        agentName: "Collette",
        desc: "Iconic Israel",
        price: "$2,999",
        logo: "Deals/agents/collette.png",
        link:
          "https://www.gocollette.com/en/tours/asia/israel/israel-a-journey-to-the-holy-land",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "christian",
      },
      {
        agentName: "Isram ISrael",
        desc: "The Ultimate Family Tour",
        price: "$2121",
        logo: "Deals/agents/isramisrael.png",
        link:
          "https://isramisraelusa.com/packages/ultimate-family-bar-bat-mitzvah-tour/",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "general",
      },
      {
        agentName: "Isram ISrael",
        desc: "The Ultimate Family Tour",
        price: "$2121",
        logo: "Deals/agents/isramisrael.png",
        link:
          "https://isramisraelusa.com/packages/ultimate-family-bar-bat-mitzvah-tour/",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "general",
      },
      {
        agentName: "Ya'lla Tours USA",
        desc: "Jewish-focused itinerary",
        price: "$2121",
        logo: "Deals/agents/yalla.jpg",
        link: "https://www.yallatours.com/israel/best_of_israel.shtml",
        imgArrowWhite: "arrowwright.svg",
        book_now: "BOOK NOW",
        category: "general",
      },
    ];
  }

  render() {
    // console.log(this.props.category);
    const dealsHtml = this.deals.map((o) => {
      if (this.props.category == o.category) {
        // console.log(" o.category: ", o.category);
        return (
          <DealItem
            agentName={o.agentName}
            price={o.price}
            logo={o.logo}
            desc={o.desc}
            link={o.link}
            imgArrowWhite={o.imgArrowWhite}
            key={o.link}
          />
        );
      }
    });
    return (
      <div className="deals-wrapper">
        <SimpleSlider settings={this.dealsSliderSettings}>
          {dealsHtml}
        </SimpleSlider>
      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js